import { render } from "./ai_list.vue?vue&type=template&id=3a641495&scoped=true"
import script from "./ai_list.js?vue&type=script&lang=js"
export * from "./ai_list.js?vue&type=script&lang=js"

import "./ai_list.vue?vue&type=style&index=0&id=3a641495&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a641495"]])

export default __exports__